export const endpoints = {
	loginAdmin: "/admin/user/login",
	forgotPassword: "/admin/user/password/reset/initiate",
  verifyEmail: '/admin/user/email/verify',
	resendVerificationEmail: (email: string) => `/admin/user/email/resend-verification/${email}`,
	resetPassword: "/admin/user/password/reset/complete",
	getDashboardSummary: "/admin/dashboard/overview",
	getUserMetrics: "/admin/dashboard/user-metrics",
	getTransactionMetrics: "/admin/dashboard/transaction-metrics",
	getSchoolPaymentMetrics: "/admin/dashboard/school_payment-metrics",
	getActivities: "/admin/user/activity-logs",
	getBooksStats: "/admins/books/stats",
	getSchoolPayments: "/admin/dashboard/school-payment-records",
	downloadSchoolPayments: "/admin/dashboard/school-payment-records/download",
	getBook: (id: string) => `/admins/books/${id}`,
	createBook: "/admins/books",
	getTransactionStats: "/transactions/stats",
	getAllTransactions: "/admin/dashboard/transactions-records",
	downloadTransactions: "/admin/dashboard/transactions/download-transaction-records",
	getTransaction: (id: string) => `/transactions/${id}`,
	requeryTransaction: "/transactions/requery",
	getWalletStats: "/admins/wallets/stats",
	getAllWallets: "/admins/wallets",
	getAllWalletsReports: "/admins/wallets/transactions",
	getWalletDetails: (id: string) => `/admins/wallets/${id}`,
	getUserWalletTransactions: (id: string) =>
		`/admins/wallets/${id}/transactions`,
	debitUserWallet: "/admins/wallets/debit",
	getUserStats: "/admins/users/stats",
	getAllUsers: "/admin/clientmanager",
	getUserData: (id: string) => `/admin/clientmanager/${id}`,
	enableUser: (id: string) => `/admin/clientmanager/enable/${id}`,
	disableUser: (id: string) => `/admin/clientmanager/disable/${id}`,
	approveUserKyc: (id: string) => `/admin/clientmanager/kyc/${id}`,
	rejectUserKyc: (id: string) => `/admin/clientmanager/kyc/${id}/reject`,
	createAdmin: "/admin/user",
	getAllAdmins: "/admin/user",
	getAdmin: (id: string) => `/admins/${id}`,
	updateAdmin: (id: string) => `/admins/${id}`,
	getPermissionsList: "/role/permissions",
	getAllRolesAndPermissions: "/role",
	getRole: (id: string) => `/role/${id}`,
	createRole: "/role",
	updateRole: (id: string) => `/roles/${id}`,
	deleteRole: (id: string) => `/role/${id}`,
};
